import { render, staticRenderFns } from "./BaseCollapsible.vue?vue&type=template&id=8c5e1488&scoped=true&"
import script from "./BaseCollapsible.vue?vue&type=script&lang=ts&"
export * from "./BaseCollapsible.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCollapsible.vue?vue&type=style&index=0&id=8c5e1488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5e1488",
  null
  
)

export default component.exports